export const TopDivider = () => {
  return (
    <div className="top-divider">
      <svg
        className="top-divider__shadow"
        width="711"
        height="200"
        viewBox="0 0 711 200"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M711.407 0H264.348C417.979 10.1162 349.761 13.1083 240.973 17.8798C184.262 20.3673 116.524 23.3383 63.4433 28.0543C425.528 30.4673 401.774 38.2734 106.882 46.1538C-117.258 52.1436 56.839 58.6193 212.889 64.4237C262.147 66.2559 309.607 68.0212 342.176 69.6833C356.417 70.41 369.562 71.0505 381.473 71.6308C483.108 76.583 494.945 77.1597 331.317 89.5928C249.849 95.783 338.95 101.848 430.971 108.112C545.435 115.903 664.417 124.002 465.253 133.032C477.841 133.838 489.9 134.608 501.428 135.344C722.795 149.476 748.255 151.102 555.751 157.939C629.684 162.346 672.493 165.158 655.299 181.9C732.222 184.163 698.69 188.993 671.588 188.235L711.407 200V0ZM609.744 93.2127C646.561 93.2127 667.969 90.3765 667.969 86.8778C667.969 83.3792 646.561 83.2579 609.744 83.2579C572.928 83.2579 543.082 83.3792 543.082 86.8778C543.082 90.3765 572.928 93.2127 609.744 93.2127Z"
          fill="#49F1C1"
        />
      </svg>
    </div>
  );
};

export const BottomDivider = () => {
  return (
    <div className="bottom-divider">
      <div className="bottom-divider__line"></div>
    </div>
  );
};
